<template>
  <div class="pt-page pt-page-current pt-page-resume pt-page-4 show-overflow" >
    <router-link class="top-nav" to="/about"><i class="fa fa-arrow-left"></i></router-link>
    <a class="logo" href="/">OM</a>
    <div class="container resume-container">
      <div class="row header text-center godown">
        <div class="col-sm-12">
          <h1>Ollie <span>Murphy</span></h1>
          <ul class="top-list">
            <li>Las Vegas, NV</li>
            <li><a href="http://www.olliemurphy.com/">www.olliemurphy.com</a></li>
            <li><a href="https://github.com/omurphy27" target="_blank"><i class="fa fa-github"></i></a></li>
            <li><a href="http://stackoverflow.com/users/1547553/ollie-murphy" target="_blank"><i class="fa fa-stack-overflow"></i></a></li>
          </ul>
        </div>
      </div>
      <div class="row first">
        <div class="col-sm-12 godown">
          <h2>Experience</h2>
        </div>
        <div class="col-sm-6 goright">
          <h3><a href="https://mobilesoft.com/" target="_blank">Mobilesoft</a></h3>
          <h4>Full Stack Developer</h4>
          <p>Las Vegas, Nevada</p>
          <p><em>February 2017 - Present</em></p>
          <ul>
            <li>Develop REST and GraphQL APIs</li>
            <li>Deploy with AWS Elastic Container Service, Elastic Beanstalk and Lambda</li>
            <li>Integrate various 3rd party services and functionality, such as electronic signatures, into mobile apps supported by a back-end admin dashboard</li>
            <li>Implement various front end designs and interfaces, including for the main company website</li>
            <li>Develop and publish mobile apps on iOS and Android</li>
            <li>Maintain and refactor legacy APIs and applications</li>
            <li>Manage a team of developers</li>
          </ul>
        </div>
        <div class="col-sm-6 goleft">
          <h3>Freelance Remote</h3>
          <h4>Full Stack Web Developer</h4>
          <p>Bangkok, Las Vegas, Saigon, Singapore</p>
          <p><em>December 2015 - February 2017</em></p>
          <ul>
            <li>Develop custom web apps, including all front end &amp; back end functionality</li>
            <li>Refactor legacy code to use modern practices and frameworks</li>
            <li>Develop high speed and real time search solutions</li>
            <li>Optimize website code and database performance</li>
            <li>Manage deployment and server administration</li>
            <li>Design and develop admin dashboards</li>
            <li>Develop custom Wordpress plugins</li>
            <li>Develop Single Page Applications</li>
          </ul>
        </div>
      </div>
      <div class="row second">
        <div class="col-sm-6 goright animated">
          <h3><a href="http://www.jenniferwebdesignlasvegas.com/" target="_blank">Jennifer Web Design</a></h3>
          <h4>Web Developer and lead SEO</h4>
          <p>Las Vegas, Nevada</p>
          <p><em>October 2012 - December 2015</em></p>
          <ul>
            <li>Develop eCommerce websites in a variety of platforms, including WooCommerce,
              Magento, 3DCart, Volusion and Shopify</li>
            <li>Integrate, troubleshoot and customize all manner of third party plugins</li>
            <li>Build custom Wordpress websites from start to finish</li>
            <li>Design and develop custom front-end effects and UI</li>
            <li>Manage projects and clients directly</li>
            <li>Create fully responsive websites</li>
            <li>Lead SEO strategy</li>
          </ul>
        </div>
        <div class="col-sm-6 goleft animated">
          <h3><a href="http://www.gemini-arcade-palace.com/" target="_blank">Gemini Arcade Palace</a></h3>
          <h4>Manager in family business</h4>
          <p>Las Vegas, Nevada</p>
          <p>May 2012 - April 2013</p>
          <ul>
            <li>Setup anime convention arcade rooms</li>
            <li>Maintain and repair arcade machines</li>
            <li>Negotiate contracts with clients</li>
            <li>Manage day to day activities</li>
            <li>Organize tournaments</li>
            <li>Maintain website</li>
          </ul>
        </div>
      </div>
      <div class="row third">
        <div class="col-sm-6 goright animated">
          <h3>Triton Internet Services Pvt Ltd</h3>
          <h4>Founder</h4>
          <p>Bangalore, India</p>
          <p>March 2010 - May 2012</p>
          <ul>
            <li>Manage employees and contractors</li>
            <li>Develop Wordpress themes</li>
            <li>On page SEO optimization</li>
            <li>Content writing, blogging</li>
            <li>Slice PSD to HTML/CSS</li>
            <li>SEO and link building</li>
            <li>Perform bookkeeping</li>
            <li>Create web graphics</li>
            <li>Generate leads</li>
          </ul>
        </div>
        <div class="col-sm-6 goright animated">
          <h3><a href="http://www.idealo.de/" target="_blank">Idealo Internet GmbH</a></h3>
          <h4>UK Team Member</h4>
          <p>Berlin, Germany</p>
          <p>Officially employed during December 2007 - April 2008<br>Freelancing
            for company from May 2008 - October 2012</p>
          <ul>
            <li>Editor and chief contributor to <a href="http://news.idealo.co.uk/"
                target="_blank">UK news blog</a></li>
            <li>SEO, internet marketing and link building</li>
            <li>German to English translation</li>
            <li>Maintain Wordpress sites</li>
            <li>Add products to database</li>
            <li>Sales</li>
          </ul>
        </div>
      </div>
      <div class="row fourth">
        <div class="col-sm-6 goright animated">
          <h3><a href="http://www.edgewave.com/" target="_blank">St Bernard Software</a></h3>
          <h4>Internet Analyst</h4>
          <p>San Diego, California</p>
          <p>March 2007 - September 2007</p>
          <ul>
            <li>Update company database</li>
            <li>Analyze internet content</li>
          </ul>
        </div>
      </div>
      <div class="row portfolio">
        <div class="col-sm-12 godown one animated">
          <h2>Portfolio</h2>
        </div>
        <div class="col-sm-4 goright one animated">
          <h3><a href="https://zverg.com" target="_blank">Zverg</a></h3>
          <h4>Web App with Real Time Commenting</h4>
          <p>Developed with Laravel, Angular.js, Socket.io and Node.js</p>
        </div>
        <div class="col-sm-4 goright two animated">
          <h3><a href="https://profiles.wordpress.org/omurphy/#content-plugins" target="_blank">Wordpress Plugins</a></h3>
          <h4>Plugins for WooCommerce and Gravity Forms</h4>
          <p>Developed with HTML, PHP and Javascript</p>
        </div>
        <div class="col-sm-4 goright three animated">
          <h3><a href="/portfolio/upwork" >Client Reviews</a></h3>
          <h4>Read reviews from happy freelance clients</h4>
        </div>
        <div class="col-sm-12 goright four animated">
          <p class="resume-portfolio-link"><em>*Additional work samples viewable on my <a href="/portfolio" >portfolio page.</a></em></p>
        </div>
      </div>
      <div class="row skills">
        <div class="col-sm-12 godown animated">
          <h2>Skills</h2>
        </div>
        <div class="col-sm-6 goright animated">
          <h3>Web Development</h3>
          <ul class="two-columns">
            <li>Javascript</li>
            <li>PHP</li>
            <li>Vue</li>
            <li>Mysql</li>
            <li>Angular</li>
            <li>PostgreSQL</li>
            <li>Node</li>
            <li>Laravel</li>
            <li>React</li>
            <li>TDD</li>
            <li>Jquery</li>
            <li>Wordpress</li>
            <li>Python</li>
            <li>AWS</li>
            <li>CSS</li>
            <li>Docker</li>
            <li>SASS</li>
            <li>Bash</li>
            <li>Bootstrap</li>
            <li>HTML</li>
          </ul>
        </div>
        <div class="col-sm-6 goleft animated">
          <h3>General</h3>
          <ul class="two-columns">
            <li>MS Word</li>
            <li>MS Excel</li>
            <li>Mac OS X</li>
            <li>Adobe Photoshop</li>
            <li>Google AdWords</li>
            <li>Google Webmaster Tools</li>
            <li>Google Analytics</li>
            <li>Moz SEO Tools</li>
          </ul>
        </div>
      </div>
      <div class="row bottom">
        <div class="col-sm-6 goright animated">
          <h2>Education</h2>
          <h3>University of California, San Diego</h3>
          <h4>BA, Economics</h4>
          <p><em>2003 - 2007</em></p>
          <p>GPA: 3.426</p>
        </div>
        <div class="col-sm-6 goleft animated">
          <h2>Activities</h2>
          <ul class="two-columns">
            <li>Jogging</li>
            <li>Swimming</li>
            <li>Travel</li>
            <li>Video Games</li>
            <li>Boxing</li>
            <li>Ice Skating</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "../assets/css/font-awesome.min.css";
</style>

<style lang="scss">
@import "../assets/scss/resume.scss";
</style>

<script>
import JQuery from "jquery";
const $ = JQuery;

export default {
  name: "Resume",
  mounted: function() {
    const $page = $(".pt-page");
    if ( $page.hasClass('show-overflow') ) {
      $page.find(".header").addClass("animated fadeInDown");

      var $first = $(".first"),
        $firstDown = $first.find(".godown"),
        $firstLeft = $first.find(".goleft"),
        $firstRight = $first.find(".goright");

      setTimeout(function() {
        $firstDown.addClass("animated fadeInDown");
      }, 350);

      setTimeout(function() {
        $firstRight.addClass("animated fadeInRight");
        $firstLeft.addClass("animated fadeInLeft");
      }, 600);
    }
  }
};
</script>
